import { jsx as l } from "react/jsx-runtime";
import { forwardRef as f, useState as a, useEffect as d, Children as u, cloneElement as w } from "react";
import g from "./iconbutton.module.js";
const B = f(({ children: o, onClick: n, ariaLabel: h, disabled: r, size: t = "m", ...s }, m) => {
  const [e, i] = a({
    height: 24,
    width: 24
  });
  return d(() => {
    t === "s" ? i({ height: 16, width: 16 }) : t === "l" && i({ height: 32, width: 32 });
  }, [t]), /* @__PURE__ */ l(
    "button",
    {
      className: g.iconButton,
      ref: m,
      onClick: n,
      "aria-label": h,
      disabled: r,
      ...s,
      children: u.map(
        o,
        (c) => w(c, {
          width: e.width,
          height: e.height
        })
      )
    }
  );
});
export {
  B as IconButton
};
